import { memo } from 'react';

import { InceptIcon, InceptIconProps } from '../InceptIcon';

const IconAssetPrimeMoverComponent: React.FC<InceptIconProps> = ({
  color = 'var(--chakra-colors-brand-primary-fg, currentColor)',
  brandColor = 'var(--chakra-colors-brand-primary-solid)',
  fillColor = 'var(--chakra-colors-brand-primary-contrast)',
  viewBox = '0 0 80 80',
  ...props
}: InceptIconProps) => (
  <InceptIcon viewBox={viewBox} {...props}>
    <g
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="0.75"
    >
      <path
        d="M67.545 44.688c-1.375-.796-1.375-3.386 0-5.776s3.605-3.684 4.98-2.89l-4.415-2.56c-1.375-.795-3.605.495-4.98 2.89s-1.375 4.98 0 5.776z"
        fill={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M67.545 45.188a.5.5 0 0 1-.25-.066l-4.41-2.56c-1.635-.95-1.72-3.784-.185-6.46.965-1.68 2.355-2.9 3.71-3.264.725-.196 1.4-.126 1.95.194l4.415 2.56a.5.5 0 0 1 .18.686.5.5 0 0 1-.685.18c-.325-.19-.725-.22-1.19-.096-1.09.29-2.28 1.365-3.105 2.8-1.215 2.116-1.3 4.446-.185 5.096a.503.503 0 0 1-.255.935zm-.345-11.46q-.246 0-.53.075c-1.09.29-2.28 1.364-3.105 2.8-1.215 2.114-1.3 4.444-.185 5.094l2.71 1.57c-.25-1.285.085-2.975 1.02-4.605.91-1.58 2.185-2.754 3.465-3.19l-2.715-1.575a1.33 1.33 0 0 0-.665-.17z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M67.545 44.688c1.375.794 3.605-.495 4.98-2.89s1.375-4.98 0-5.776c-1.375-.794-3.605.495-4.98 2.89s-1.375 4.98 0 5.776"
        fill={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M68.46 45.423c-.425 0-.82-.1-1.165-.306-1.64-.95-1.72-3.784-.185-6.454.965-1.68 2.355-2.9 3.71-3.265.725-.196 1.4-.126 1.95.194 1.635.95 1.72 3.785.185 6.46-.965 1.68-2.355 2.9-3.71 3.266-.27.07-.535.11-.785.11zm3.15-9.135q-.246 0-.53.075c-1.09.29-2.28 1.364-3.105 2.8-1.215 2.115-1.3 4.445-.185 5.095.325.19.725.22 1.19.094 1.09-.29 2.28-1.364 3.105-2.8 1.215-2.114 1.3-4.444.185-5.094a1.33 1.33 0 0 0-.665-.17z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M33.99 64.153c-1.375-.796-1.375-3.386 0-5.776s3.605-3.684 4.98-2.89l-4.415-2.56c-1.375-.794-3.605.495-4.98 2.89-1.375 2.39-1.375 4.98 0 5.776z"
        fill={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M33.99 64.653a.5.5 0 0 1-.25-.066l-4.41-2.56c-1.635-.95-1.72-3.785-.185-6.46.965-1.68 2.355-2.9 3.71-3.264.725-.195 1.4-.125 1.95.195l4.415 2.56a.5.5 0 0 1 .18.684.5.5 0 0 1-.685.18c-.325-.19-.725-.22-1.19-.094-1.09.29-2.28 1.364-3.105 2.8-1.215 2.114-1.3 4.444-.185 5.094a.503.503 0 0 1-.255.935zm-.35-11.46q-.246 0-.53.075c-1.09.29-2.28 1.364-3.105 2.8-1.215 2.114-1.3 4.445-.185 5.095l2.71 1.57c-.25-1.285.085-2.975 1.02-4.605.91-1.58 2.185-2.755 3.465-3.19L34.3 53.362a1.33 1.33 0 0 0-.665-.17z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M38.958 61.233c1.37-2.394 1.36-4.976-.02-5.765-1.381-.79-3.61.51-4.98 2.905s-1.361 4.976.02 5.766c1.38.79 3.61-.511 4.98-2.906"
        fill={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M34.905 64.888c-.425 0-.82-.1-1.165-.306-1.64-.95-1.72-3.784-.185-6.454.965-1.68 2.355-2.9 3.71-3.266.725-.195 1.4-.125 1.95.195 1.635.95 1.72 3.785.185 6.456-.965 1.68-2.355 2.9-3.71 3.265-.27.07-.535.11-.785.11m-.665-1.17c.325.19.725.22 1.19.094 1.09-.29 2.28-1.364 3.105-2.8 1.215-2.114 1.3-4.444.18-5.095-.325-.19-.725-.22-1.19-.095-1.09.29-2.28 1.365-3.105 2.8-1.215 2.115-1.3 4.446-.185 5.096z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m77.49 26.218-39.175 22.76-.02-.01-11.475-6.656-6.98-4.044 39.175-22.766z"
        fill={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M38.315 49.478a.5.5 0 0 1-.275-.08l-18.45-10.7a.5.5 0 0 1-.25-.435c0-.18.095-.346.25-.43l39.175-22.76a.5.5 0 0 1 .5 0L77.74 25.788c.155.09.25.255.25.434 0 .18-.095.345-.25.43l-39.175 22.76a.5.5 0 0 1-.25.07zm-17.48-11.215 17.48 10.135 38.18-22.186-17.48-10.134z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m64.525 21.323-5.75-3.32-5.745 3.32v7.005l5.745 3.32 5.75-3.32z"
        fill={brandColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m57.158 25.583-5.75-3.32-5.745 3.32v7.005l5.745 3.32 5.75-3.32z"
        fill={brandColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M51.41 36.408a.5.5 0 0 1-.25-.066l-5.75-3.32a.5.5 0 0 1-.25-.434v-7.006c0-.18.095-.344.25-.434l5.745-3.325a.5.5 0 0 1 .5 0l5.75 3.32c.155.09.25.255.25.434v7.006c0 .18-.095.345-.25.434l-5.75 3.32a.5.5 0 0 1-.25.066zm-5.25-4.11 5.25 3.035 5.25-3.035v-6.426l-5.25-3.035-5.245 3.035v6.426z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m49.79 29.843-5.75-3.32-5.745 3.32v7.004l5.745 3.32 5.75-3.32z"
        fill={brandColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M44.04 40.668a.5.5 0 0 1-.25-.066l-5.75-3.32a.5.5 0 0 1-.25-.434v-7c0-.18.096-.345.25-.435l5.746-3.326a.5.5 0 0 1 .5 0l5.75 3.326c.154.09.25.255.25.434v7c0 .18-.096.346-.25.435l-5.75 3.32a.5.5 0 0 1-.25.066zm-5.245-4.11 5.25 3.035 5.25-3.036v-6.425l-5.25-3.035-5.245 3.035v6.425z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m42.423 34.103-5.75-3.32-5.745 3.32v7.005l5.745 3.32 5.75-3.32z"
        fill={brandColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M36.675 44.928a.5.5 0 0 1-.25-.066l-5.75-3.325a.5.5 0 0 1-.25-.434v-7c0-.18.095-.346.25-.436l5.745-3.325a.5.5 0 0 1 .5 0l5.75 3.32c.155.09.25.255.25.435v7c0 .18-.095.346-.25.435l-5.75 3.326a.5.5 0 0 1-.25.065zm-5.25-4.11 5.25 3.035 5.25-3.035v-6.425l-5.25-3.035-5.245 3.034v6.426z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m71.905 25.589-5.75-3.32-5.745 3.32v7.005l5.745 3.32 5.75-3.32z"
        fill={brandColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m64.54 29.853-5.75-3.32-5.745 3.32v7.005l5.745 3.32 5.75-3.32z"
        fill={brandColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M58.79 40.678a.5.5 0 0 1-.25-.066l-5.75-3.325a.5.5 0 0 1-.25-.434v-7c0-.18.096-.346.25-.436l5.746-3.32a.5.5 0 0 1 .5 0l5.75 3.32c.154.09.25.255.25.435v7c0 .18-.096.346-.25.436l-5.75 3.325a.5.5 0 0 1-.25.065zm-5.245-4.11 5.25 3.035 5.25-3.035v-6.425l-5.25-3.035-5.245 3.034v6.426z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m57.173 34.113-5.75-3.32-5.745 3.32v7.005l5.745 3.32 5.75-3.32z"
        fill={brandColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M51.425 44.938a.5.5 0 0 1-.25-.066l-5.75-3.325a.5.5 0 0 1-.25-.434v-7c0-.18.095-.346.25-.435l5.745-3.325a.5.5 0 0 1 .5 0l5.75 3.32c.155.09.25.255.25.434v7c0 .18-.095.346-.25.435l-5.75 3.325a.5.5 0 0 1-.25.066zm-5.25-4.11 5.25 3.034 5.25-3.035v-6.424l-5.25-3.035-5.245 3.035v6.425z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m49.806 38.373-5.75-3.32-5.745 3.32v7.005l5.745 3.32 5.75-3.32z"
        fill={brandColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M44.06 49.198a.55.55 0 0 1-.25-.066l-5.75-3.325a.5.5 0 0 1-.25-.434v-7c0-.18.096-.345.25-.435l5.746-3.326a.5.5 0 0 1 .5 0l5.75 3.325c.155.09.25.256.25.436v7c0 .18-.095.345-.25.434l-5.75 3.325a.5.5 0 0 1-.25.066zm-5.25-4.11 5.25 3.035 5.25-3.035v-6.425l-5.25-3.035-5.245 3.035v6.425z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m43.806 43.373-5.75-3.32-5.745 3.32v7.005l5.745 3.32 5.75-3.32z"
        fill={brandColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M38.06 54.198a.55.55 0 0 1-.25-.066l-5.75-3.325a.5.5 0 0 1-.25-.434v-7c0-.18.096-.345.25-.435l5.746-3.326a.5.5 0 0 1 .5 0l5.75 3.325c.155.09.25.256.25.436v7c0 .18-.095.345-.25.434l-5.75 3.325a.5.5 0 0 1-.25.066zm-5.25-4.11 5.25 3.035 5.25-3.035v-6.425l-5.25-3.035-5.245 3.035v6.425z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M6.01 40.393c-.19.084-.65.264-1.24.184a2.3 2.3 0 0 1-1.265-.614v-3.63a2.57 2.57 0 0 1 2.505.43z"
        fill={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M5.07 41.093a2.797 2.797 0 0 1-1.915-.775.5.5 0 0 1-.155-.36v-3.63c0-.21.13-.4.33-.47.335-.12.875-.245 1.515-.15.685.105 1.185.42 1.485.665a.5.5 0 0 1 .185.385v3.63a.5.5 0 0 1-.295.455c-.265.12-.66.25-1.145.25zM4 39.727c.185.14.465.3.835.35.26.035.485.01.675-.04v-3.024c-.2-.13-.475-.26-.82-.316a2.1 2.1 0 0 0-.69.01z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m38.315 34.787-12.94 7.51c-.575.33-.925 1.61-.925 1.61L5.975 33.192s.355-1.28.925-1.61l12.94-7.51z"
        fill={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M24.445 44.413a.55.55 0 0 1-.25-.066L5.72 33.632a.5.5 0 0 1-.23-.564c.07-.245.445-1.5 1.16-1.91l12.94-7.51a.5.5 0 0 1 .5 0l18.475 10.714a.502.502 0 0 1 0 .87l-12.94 7.51c-.255.15-.57.86-.695 1.31a.5.5 0 0 1-.485.365zM6.575 32.968l17.6 10.21c.19-.465.505-1.05.95-1.31l12.195-7.076-17.48-10.135-12.69 7.366c-.195.114-.425.55-.575.95z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m24.445 43.912-1.725 11.01L4.245 44.207l1.725-11.01z"
        fill={brandColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M22.72 55.423a.5.5 0 0 1-.25-.066L3.995 44.643a.5.5 0 0 1-.245-.51l1.725-11.014a.5.5 0 0 1 .28-.376.5.5 0 0 1 .465.02l18.475 10.715c.18.106.275.306.245.51l-1.725 11.015a.5.5 0 0 1-.28.375.5.5 0 0 1-.215.05zM4.795 43.947 22.34 54.124l1.56-9.955L6.355 33.992z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M22.72 54.923v7.98c0 .715.385 1.3.925 1.61L5.17 53.797a1.85 1.85 0 0 1-.925-1.61v-7.98z"
        fill={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M23.645 65.013a.5.5 0 0 1-.25-.066L4.925 54.233a2.34 2.34 0 0 1-1.175-2.044v-7.98a.502.502 0 0 1 .75-.435l18.475 10.714c.155.09.25.255.25.435v7.98c0 .49.255.935.675 1.18a.503.503 0 0 1-.255.935zm-18.9-19.936v7.11c0 .495.255.936.675 1.18l16.805 9.75a3 3 0 0 1-.01-.21v-7.69L4.74 45.084z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m22.725 59.358-4.605-2.67v2.354l4.605 2.67z"
        fill={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M22.725 62.213a.55.55 0 0 1-.25-.066l-4.605-2.67a.5.5 0 0 1-.25-.434v-2.355a.502.502 0 0 1 .75-.436l4.605 2.67c.155.09.25.256.25.436v2.355c0 .18-.095.344-.25.434a.5.5 0 0 1-.25.066m-4.105-3.456 3.605 2.09v-1.2l-3.605-2.09z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M18.12 59.043v2.264l4.605 2.67v-2.264z"
        fill={brandColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M22.725 64.478a.5.5 0 0 1-.25-.066l-4.605-2.67a.5.5 0 0 1-.25-.434v-2.26a.502.502 0 0 1 .75-.436l4.605 2.67c.155.09.25.256.25.436v2.264c0 .18-.095.346-.25.436a.5.5 0 0 1-.25.064zm-4.105-3.46 3.605 2.09v-1.105l-3.605-2.09z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M4.305 52.223c0 .72.39 1.3.93 1.61l3.675 2.13v-2.26l-4.605-2.67z"
        fill={brandColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M8.91 56.463a.5.5 0 0 1-.25-.066l-3.675-2.13a2.33 2.33 0 0 1-1.18-2.045v-1.19a.502.502 0 0 1 .75-.434l4.605 2.67c.155.09.25.255.25.434v2.26c0 .18-.095.345-.25.435a.5.5 0 0 1-.25.066m-4.105-4.56v.32c0 .49.255.93.68 1.175l2.925 1.694v-1.105l-3.605-2.09z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M4.305 48.678v2.355l4.605 2.67v-2.356z"
        fill={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M8.91 54.203a.5.5 0 0 1-.25-.066l-4.605-2.67a.5.5 0 0 1-.25-.434v-2.355a.502.502 0 0 1 .75-.435l4.605 2.67c.155.09.25.255.25.434v2.355c0 .18-.095.346-.25.436a.5.5 0 0 1-.25.065m-4.105-3.46 3.605 2.09v-1.2l-3.605-2.09z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M38.315 48.978v-14.19l-12.94 7.51c-.575.334-.925 1.61-.925 1.61l-1.725 11.014v7.98c0 .715.385 1.3.925 1.61.54.316 1.235.36 1.855 0l6.065-3.514c.14-1.07.525-2.215 1.175-3.345 1.345-2.34 3.43-3.85 5.315-3.85.595 0 1.145.145 1.635.43.53.31.95.765 1.245 1.33l24.185-14.026c.14-1.07.525-2.215 1.175-3.35 1.345-2.34 3.43-3.85 5.315-3.85.595 0 1.145.145 1.635.43.53.31.95.765 1.245 1.33l2.075-1.2c.575-.33.925-.944.925-1.61v-7.064l-39.18 22.76z"
        fill={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M24.575 65.268c-.405 0-.81-.106-1.175-.32a2.34 2.34 0 0 1-1.175-2.045v-7.98q-.001-.038.005-.076l1.725-11.014s.005-.04.01-.055c.07-.245.445-1.5 1.16-1.91l12.94-7.51a.502.502 0 0 1 .75.435v13.32l38.43-22.325a.502.502 0 0 1 .75.435v7.065c0 .84-.45 1.625-1.175 2.045l-2.075 1.2a.5.5 0 0 1-.39.05.5.5 0 0 1-.305-.25 2.75 2.75 0 0 0-1.055-1.13 2.73 2.73 0 0 0-1.385-.366c-1.71 0-3.625 1.41-4.88 3.6-.595 1.03-.975 2.126-1.11 3.166a.5.5 0 0 1-.245.37L41.19 55.997a.5.5 0 0 1-.39.05.5.5 0 0 1-.305-.25 2.75 2.75 0 0 0-1.055-1.13c-.415-.24-.88-.36-1.385-.36-1.71 0-3.625 1.41-4.88 3.6-.595 1.03-.975 2.124-1.11 3.16a.5.5 0 0 1-.245.37l-6.065 3.514c-.37.216-.775.32-1.175.32zM23.22 54.962v7.94a1.352 1.352 0 0 0 2.025 1.18l5.855-3.394c.175-1.09.59-2.22 1.2-3.285 1.43-2.49 3.69-4.1 5.75-4.1.68 0 1.315.165 1.885.495.46.27.855.63 1.17 1.084l23.555-13.66c.175-1.09.59-2.224 1.2-3.285 1.43-2.49 3.69-4.1 5.75-4.1a3.67 3.67 0 0 1 3.06 1.585l1.65-.954c.415-.24.675-.696.675-1.18v-6.2l-38.43 22.325a.502.502 0 0 1-.75-.435v-13.32l-12.19 7.075c-.25.145-.555.83-.69 1.285z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M36.055 39.213v7.47l-10.4 6.03 1.725-8.465z"
        fill={brandColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M25.655 53.213a.47.47 0 0 1-.29-.096.51.51 0 0 1-.2-.505l1.725-8.47c.03-.14.115-.26.24-.335l8.68-5.035a.502.502 0 0 1 .75.435v7.47c0 .18-.095.346-.25.435l-10.405 6.035a.5.5 0 0 1-.25.066m2.17-8.645-1.46 7.154 9.19-5.33v-6.31l-7.735 4.486z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M28.11 53.208c-.19.084-.65.264-1.24.184a2.3 2.3 0 0 1-1.265-.614v-3.63a2.57 2.57 0 0 1 2.505.43z"
        fill={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M27.175 53.913a2.797 2.797 0 0 1-1.915-.775.5.5 0 0 1-.155-.36v-3.63c0-.21.13-.4.33-.47.335-.12.875-.245 1.515-.15.685.105 1.185.42 1.485.665a.5.5 0 0 1 .185.385v3.63a.5.5 0 0 1-.295.455c-.265.12-.66.25-1.145.25zm-1.07-1.365c.185.14.465.3.835.35.26.034.49.01.675-.04v-3.025c-.2-.13-.475-.26-.82-.316a2.1 2.1 0 0 0-.69.01z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M24.385 55.767a.5.5 0 0 1-.5-.5c0-.8.085-.915.765-1.6.39-.39.43-.75.445-.885.035-.31.21-.43.35-.475a.5.5 0 0 1 .63.315c.03.095.035.19.01.275a2.43 2.43 0 0 1-.73 1.475q-.475.48-.475.895c0 .275-.225.5-.5.5z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
    </g>
  </InceptIcon>
);

export const IconAssetPrimeMover = memo(IconAssetPrimeMoverComponent);
